import { render } from "./CompanyDeploy.vue?vue&type=template&id=21e95b98"
import script from "./CompanyDeploy.vue?vue&type=script&lang=js"
export * from "./CompanyDeploy.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__